<svg xmlns="http://www.w3.org/2000/svg" width="42" height="42" fill="none" viewBox="0 0 42 42">
  <path fill-rule="evenodd" d="M12 14h2v6h4v-6h2v14h-2v-6h-4v6h-2V14Z" clip-rule="evenodd"/>
  <path d="M28 14h-2l-4 7v3h6v4h2V18h-2v4h-4v-1l4-7Z"/>
</svg>
